import React from 'react'
import './MovimentacaoContainerItem.css'

export default function MovimentacaoContainerItem({
  line1 = null,
  line2 = null,
  line3 = null,
  line4 = null,
  onClick,
  selected = null,
  alocated = null,
  success = null,
}) {
  function ifExistsShow(item) {
    if (item) return <span>{item}</span>
  }

  return (
    <div
      className={`movimentacao-container-item ${selected ? 'selected' : 'not-selected'} ${alocated ? 'alocated' : ''} ${success ? 'success' : ''}`}
      onClick={onClick}
    >
      {ifExistsShow(line1)}
      {ifExistsShow(line2)}
      {ifExistsShow(line3)}
      {ifExistsShow(line4)}
    </div>
  )
}
